// extracted by mini-css-extract-plugin
module.exports = {"report-loading":"report-loading_report-loading__a6KYG","report-loading__text":"report-loading_report-loading__text__cLWRE"};